import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

type DeleteFavoriteMaterialParams = {
  gfMaterialId: number;
};
type DeleteFavoriteMaterialResponse = APIResponse<null>;

export const deleteFavoriteMaterial = async (params: DeleteFavoriteMaterialParams) => {
  try {
    return await http<DeleteFavoriteMaterialResponse>(`/user/v1/gf/materials/favorite/${params.gfMaterialId}`, {
      method: 'DELETE',
    });
  } catch (error) {
    console.error('deleteFavoriteMaterial Error', error);
    throw error;
  }
};
